import { useQuery } from "@tanstack/react-query"
import { usePathname } from "next/navigation"

import {
  DEFAULT_QUERY_CACHE_TIME as QUERY_CACHE_TIME,
  DEFAULT_QUERY_STALE_TIME as QUERY_STALE_TIME,
} from "@/modules/api/constants"
import { useLocale } from "@/modules/locales/useLocale"
import { getNotificationBanner } from "@/modules/notificationBanner/api/getNotificationBanner"
import { getNotificationBannerQueryKey } from "@/modules/notificationBanner/services/getNotificationBannerQueryKey"
import { isBackOfficePathname } from "@/modules/routing/helpers/isBackOfficePathname"

type UseNotificationBannerResponse = {
  data: Awaited<ReturnType<typeof getNotificationBanner>>
}

export const useNotificationBanner = (): UseNotificationBannerResponse => {
  const pathname = usePathname()
  const isBackend = isBackOfficePathname(pathname)
  const locale = useLocale()

  const { data } = useQuery({
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getNotificationBanner({ isBackend, locale }),
    queryKey: getNotificationBannerQueryKey({ isBackend, locale }),
    staleTime: QUERY_STALE_TIME,
  })
  // Return null to prevent error: Query data cannot be undefined.
  return { data: data || null }
}
